import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import type { Prismic } from '@landsbankinn/prismic';
import { isEmptyText, PrismicLink, PrismicText } from '@landsbankinn/prismic';
import {
  ArrowButton,
  device,
  Row,
  Segment,
  useRevealTrail,
} from '@landsbankinn/ui';
import React from 'react';
import { PointCard } from '../components/card/PointCard';
import messages from './QuartersContainer.res';

interface IProps {
  fields: IField[];
  hasContainer?: boolean;
}

interface IField {
  copy: Prismic.RichText;
  link: Prismic.Link;
  number?: number;
}

const CardItem = ({ copy, link, number, ...rest }: IField) => {
  const copyText = isEmptyText(copy) ? null : <PrismicText value={copy} />;
  const { r } = useResource();

  const linkText = r(messages.getAllDocument);
  const quarter = r(messages.quarter);

  const action = link ? (
    <PrismicLink value={link} title={linkText}>
      <ArrowButton title={linkText} isSmall isArrowDown />
    </PrismicLink>
  ) : null;

  return (
    <PointCard
      number={`${number}${quarter}`}
      copy={copyText}
      action={action}
      isSplitterLong={true}
      cols={3}
      pointColor="Auto"
      pointsType="Numbers"
      {...rest}
    />
  );
};

const ItemsRow = styled(Row)`
  margin-bottom: -2em;

  > * {
    margin-bottom: 2em;
  }

  @media ${device.tablet} {
    margin-bottom: -4em;

    > * {
      margin-bottom: 0;
    }
  }
`;

const copy = (
  <>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
  </>
);

const disabledPoints = [
  <PointCard
    key="tempq1"
    number="1F"
    copy={copy}
    isSplitterLong={true}
    cols={3}
    pointColor="Auto"
    pointsType="Numbers"
    isDisabled={true}
  />,
  <PointCard
    key="tempq2"
    number="2F"
    copy={copy}
    isSplitterLong={true}
    cols={3}
    pointColor="Auto"
    pointsType="Numbers"
    isDisabled={true}
  />,
  <PointCard
    key="tempq3"
    number="3F"
    copy={copy}
    isSplitterLong={true}
    cols={3}
    pointColor="Auto"
    pointsType="Numbers"
    isDisabled={true}
  />,
  <PointCard
    key="tempq4"
    number="4F"
    copy={copy}
    isSplitterLong={true}
    cols={3}
    pointColor="Auto"
    pointsType="Numbers"
    isDisabled={true}
  />,
];

const Group = ({ children, ...rest }: any) => {
  const { ref, itemsWithStyleProp } = useRevealTrail(children);
  return (
    <ItemsRow ref={ref} {...rest}>
      {itemsWithStyleProp}
    </ItemsRow>
  );
};

export const QuartersContainer = ({ fields, hasContainer = true }: IProps) => {
  const itemsCount = fields?.length;
  const disabledItems = disabledPoints.slice(itemsCount, 4);
  return (
    <Segment container={hasContainer}>
      <Group>
        {fields?.map((item, index) => {
          return <CardItem key={`${index}-q`} number={index + 1} {...item} />;
        })}
        {disabledItems}
      </Group>
    </Segment>
  );
};
